export default import.meta.ROLLDOWN_FILE_URL_sdvR3tpjwxgqtE4CD7BlUQ